module.exports = __webpack_public_path__ + "Tele2TextSans-Regular.d226c9af.ttf";


//////////////////
// WEBPACK FOOTER
// /var/www/build-health-2/src/assets/fonts/regular/Tele2TextSans-Regular.ttf
// module id = 2389
// module chunks = 0